import { createPageFilterContext } from '@/hooks/useFIlter/PageFilterContext';
import Event from '@/model/Event';

export const { Provider: FinancialPageProvider, usePageFilter: useFinancialPageFilter } =
  createPageFilterContext<Event>('/financial-page');

export const { Provider: EventClosePageProvider, usePageFilter: useEventClosePageFilter } =
  createPageFilterContext<Event>('/event-close-page');

export const { Provider: EventCloseCsvPageProvider, usePageFilter: useEventCloseCsvPageFilter } =
  createPageFilterContext<Event>('/event-close-csv-page');
